"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateWaitingForSessionError = exports.AvailabilityEvent = exports.ExpertEvent = exports.RelevantExpertMatcher = void 0;
var RelevantExpertMatcher;
(function (RelevantExpertMatcher) {
    RelevantExpertMatcher["default"] = "default";
    RelevantExpertMatcher["location"] = "location";
})(RelevantExpertMatcher = exports.RelevantExpertMatcher || (exports.RelevantExpertMatcher = {}));
var ExpertEvent;
(function (ExpertEvent) {
    ExpertEvent["deleted"] = "deleted";
    ExpertEvent["updated"] = "updated";
    ExpertEvent["becameActive"] = "becameActive";
    ExpertEvent["waitingForSession"] = "waitingForSession";
    ExpertEvent["availabilityStatusChanged"] = "availabilityStatusChanged";
    ExpertEvent["notWaitingForSession"] = "notWaitingForSession";
})(ExpertEvent = exports.ExpertEvent || (exports.ExpertEvent = {}));
var AvailabilityEvent;
(function (AvailabilityEvent) {
    AvailabilityEvent["ping"] = "ping";
    AvailabilityEvent["becameInactive"] = "becameInactive";
})(AvailabilityEvent = exports.AvailabilityEvent || (exports.AvailabilityEvent = {}));
var UpdateWaitingForSessionError;
(function (UpdateWaitingForSessionError) {
    UpdateWaitingForSessionError["limitReached"] = "limitReached";
    UpdateWaitingForSessionError["unavailable"] = "unavailable";
    UpdateWaitingForSessionError["inactive"] = "inactive";
    UpdateWaitingForSessionError["invalidAssignmentType"] = "invalidAssignmentType";
})(UpdateWaitingForSessionError = exports.UpdateWaitingForSessionError || (exports.UpdateWaitingForSessionError = {}));
